import React from 'react'
import BookingListTable from './Components/ParkingBookingListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const ParkingBookingList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Parking List</HeadingOne>
          <AddItemBtn url="add-booking" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <BookingListTable />
      </div>
    </PageBody>
  );
};

export default ParkingBookingList;